module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-network-tab.5224ca21.png";